<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Zielgruppen-Matrix</p>

      <h2 class="presentation-page__title">Welches Modell passt zu Ihrer Situation?</h2>

      <p class="presentation-page__text">
        Sechs typische Profile — für jedes haben wir ein passendes Strukturmodell.
      </p>

      <div class="presentation-page__matrix-cards">
        <article
          v-for="profile in profiles"
          :key="profile.letter"
          class="presentation-page__matrix-card"
        >
          <div
            :class="[
              'presentation-page__matrix-card-letter',
              `presentation-page__matrix-card-letter--${profile.accent}`,
            ]"
          >
            {{ profile.letter }}
          </div>

          <div class="presentation-page__matrix-card-content">
            <h3 class="presentation-page__matrix-card-title">{{ profile.title }}</h3>
            <p class="presentation-page__matrix-card-text">{{ profile.text }}</p>
            <div class="presentation-page__matrix-card-accent" aria-hidden="true"></div>
            <p class="presentation-page__matrix-card-benefit">{{ profile.benefit }}</p>
          </div>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage10',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      profiles: [
        {
          letter: 'A',
          accent: 'brand-primary',
          title: 'IAB-Investor',
          text: 'Selbstständige & Unternehmer mit Steuerlast',
          benefit: '→ Steuerersparnis + Beteiligung an PV-Cashflow',
        },
        {
          letter: 'B',
          accent: 'brand-secondary',
          title: 'Hallendach-Eigentümer',
          text: 'Gewerbe-, Logistik- oder Industriedach ab 500 m²',
          benefit: '→ Pachtzins ohne eigene Investition oder Risiko',
        },
        {
          letter: 'C',
          accent: 'brand-teal',
          title: 'Landwirt / Bauernhof',
          text: 'Bauernhof mit altem Tagdach, ggf. Sanierungsbedarf',
          benefit: '→ Neues Dach + jahrzehntelanger Pachtzins',
        },
        {
          letter: 'D',
          accent: 'brand-teal',
          title: 'Privathaushalt (B2C)',
          text: 'Eigenheimbesitzer mit Strombedarf',
          benefit: '→ Eigenstromnutzung + Senkung der Stromrechnung',
        },
        {
          letter: 'E',
          accent: 'brand-secondary',
          title: 'Wohnungsbau / Mieterstrom',
          text: 'MFH-Eigentümer, Genossenschaften, Bauträger',
          benefit: '→ Zusatzerlös aus Mieterstrom · ESG-Profil',
        },
        {
          letter: 'F',
          accent: 'brand-primary',
          title: 'Gewerbe-Eigennutzer',
          text: 'Unternehmen mit hohem Eigenstrombedarf',
          benefit: '→ Strompreis-Sicherheit + Klimabilanz',
        },
      ],
    };
  },
};
</script>
